import React from 'react';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import SafePureComponent from '../shared/SafePureComponent';

import './style.scss';

const Disclaimer = () => (
    <div className="disclaimer">
        <header>
            <h6><I18n k={'gig_page_perseus.disclaimer.title'}/></h6>
        </header>
        <p><I18n k={'gig_page_perseus.disclaimer.description'}/></p>
    </div>
);

export { Disclaimer };
export default SafePureComponent(Disclaimer);
